import ListingInformationPage from './ListingInformationPage.page';

export default ListingInformationPage;